import { Link } from "react-router-dom";
import { BRAND } from "../../data/content";
import { Phone, CalendarCheck, FileText, MapPin } from "lucide-react";

export const MobileCTABar = () => {
  const items = [
    { icon: Phone, label: "Call", href: BRAND.phoneHref, external: true },
    { icon: CalendarCheck, label: "Book", to: "/property-inspections/book" },
    { icon: FileText, label: "Quote", to: "/request-inspection" },
    { icon: MapPin, label: "Areas", to: "/service-areas" },
  ];
  return (
    <div
      data-testid="mobile-persistent-cta-bar"
      className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-4 gap-1 border-t border-gold/30 bg-white/95 p-2 backdrop-blur-md md:hidden"
    >
      {items.map((it) =>
        it.external ? (
          <a key={it.label} href={it.href} className="flex flex-col items-center gap-1 rounded-lg py-2 text-slate-700 active:bg-slate-100">
            <it.icon className="h-5 w-5 text-gold" />
            <span className="text-[10px] font-medium">{it.label}</span>
          </a>
        ) : (
          <Link key={it.label} to={it.to} className="flex flex-col items-center gap-1 rounded-lg py-2 text-slate-700 active:bg-slate-100">
            <it.icon className="h-5 w-5 text-gold" />
            <span className="text-[10px] font-medium">{it.label}</span>
          </Link>
        )
      )}
    </div>
  );
};
